export { default } from './GoogleAddressInput.js';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/GoogleAddressInput/index.js